module.exports = __webpack_public_path__ + "img/receipt25.b8d50f0a.png";